module.exports = __webpack_public_path__ + "static/media/ministry_approve_icon.bb1649d6.svg";